export default function MapCurrency(currency){
    if (currency == "USD"){
        return("USD $")
    }
    if (currency == "PKR"){
        return("PKR")
    }
    if (currency == "EURO"){
        return("EURO €")
    }
    
}
